/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { cruiseListRequest } from '../models/cruiseListRequest';
import type { cruiseListResponse } from '../models/cruiseListResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ListSearchService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * searches cruise offers
   * Search for cruise offers.
   *
   * This request returns a list of cruise and cruise package offers.
   *
   * Different type of compositions can be requested.
   * - all offers (only supported with filter on one JourneyIdentifier
   * CompositionType = None (Default)
   * - Cheapest offer per JourneyIdentifier and product Type
   * CompositionType = JourneyIdentifier
   * - Cheapest offer per JourneyIdentifier
   * CompositionType = JourneyIdentifierWithoutProductType
   * - Cheapest offer per JourneyIdentifier per price category and product Type              CompositionType = JourneyIdentifierPriceCategory
   * - Cheapest offer per JourneyIdentifier per price category per cabin type and product Type    CompositionType = JourneyIdentifierPriceCategoryCabinType
   *
   * Tabelle zur Request des Endpunkts <table border = black>
   * <tr>
   * <th> Name</th>
   * <th> Funktion</th>
   * </tr>
   * <tr>
   * <td> paging - resultFrom</td>
   * <td> Erstes angefragtes Element</td>
   * </tr>
   * <tr>
   * <td> paging - resultsTotal</td>
   * <td> Maximale Anzahl von Ergebnissen</td>
   * </tr>
   * <tr>
   * <td> sort - criteria</td>
   * <td> Sortierungskriterium der Ergebnisse</td>
   * </tr>
   * <tr>
   * <td> sort - direction</td>
   * <td> Sortierungsrichtung (aufsteigend vs. absteigend)</td>
   * </tr>
   * <tr>
   * <td> passenger - adults</td>
   * <td> Anzahl der Erwachsenen</td>
   * </tr>
   * <tr>
   * <td> passenger - children</td>
   * <td> Anzahl der Kinder</td>
   * </tr>
   * <tr>
   * <td> period - start - date</td>
   * <td> Frühestes Startdatum der Reise</td>
   * </tr>
   * <tr>
   * <td> period - end - date</td>
   * <td> Spätestes Enddatum der Reise</td>
   * </tr>
   * <tr>
   * <td> period - duration</td>
   * <td> Ausgewählter Reisedauer-Code</td>
   * </tr>
   * <tr>
   * <td> geoLocation - regions</td>
   * <td> Liste von ausgewählten Region-Codes</td>
   * </tr>
   * <tr>
   * <td> flight - outbound - departureAirports</td>
   * <td> Liste von IATA-Codes der Start-Flughäfen (Hinflug)</td>
   * </tr>
   * <tr>
   * <td> flight - outbound - arrivalAirports</td>
   * <td> Liste von IATA-Codes der Ziel-Flughäfen (Hinflug)</td>
   * </tr>
   * <tr>
   * <td> flight - inbound - departureAirports</td>
   * <td> Liste von IATA-Codes der Start-Flughäfen (Rückflug)</td>
   * </tr>
   * <tr>
   * <td> flight - inbound - arrivalAirports</td>
   * <td> Liste von IATA-Codes der Ziel-Flughäfen (Rückflug)</td>
   * </tr>
   * <tr>
   * <td> flight - allowOpenJaw</td>
   * <td> Hin-und Rückflug über unterschiedliche Flughäfen (false = identische Flughäfen)
   * </td>
   * </tr>
   * <tr>
   * <td> cruise - shipCodes</td>
   * <td> Liste von Schiffen (Buchungs-Codes)</td>
   * </tr>
   * <tr>
   * <td> cruise - journeyIdentifier</td>
   * <td> Liste von TripCodes</td>
   * </tr>
   * <tr>
   * <td> cruise - cabinTypes</td>
   * <td>  Liste von Kabinen-Typ-Codes</td>
   * </tr>
   * <tr>
   * <td> cruise - tariffTypes</td>
   * <td>  Liste von Tarifen </td>
   * </tr>
   * <tr>
   * <td> composition</td>
   * <td>  Anfrage-Typ - siehe Beschreibung (/cruiseList) </td>
   * </tr>
   * </table>
   *
   * Tabelle zur Response des Endpunkts <table border = black>
   * <tr>
   * <th> Name</th>
   * <th> Funktion</th>
   * </tr>
   * <tr>
   * <td> prozessInfo - success</td>
   * <td> Erfolgreiche Verarbeitung der Anfrage</td>
   * </tr>
   * <tr>
   * <td> processInfo - time</td>
   * <td> Antwortzeit der Response in ms</td>
   * </tr>
   * <tr>
   * <td> processInfo - requestId</td>
   * <td> Zeitstempel der Anfrage</td>
   * </tr>
   * <tr>
   * <td> processInfo - processMessage - messageType</td>
   * <td> Art der Nachricht (Error, ConfigurationError, Information)</td>
   * </tr>
   * <tr>
   * <td> processInfo - processMessage - processIdentifier</td>
   * <td> Identifikator des Verarbeitungsservices</td>
   * </tr>
   * <tr>
   * <td> processInfo - processMessage - messageCode</td>
   * <td> Nachrichtencode</td>
   * </tr>
   * <tr>
   * <td> processInfo - processMessage - message</td>
   * <td> Nachricht</td>
   * </tr>
   * <tr>
   * <td> lang</td>
   * <td> Zwei-Letter-Sprachencode nach ISO-639-1</td>
   * </tr>
   * <tr>
   * <td> currency</td>
   * <td> Drei-Letter-Währungscode nach ISO-4217</td>
   * </tr>
   * <tr>
   * <td> paging - resultFrom</td>
   * <td> Zähler des ersten Ergenmoselements</td>
   * </tr>
   * <tr>
   * <td> paging - resultsTotal</td>
   * <td> Anzahl der Ergebnisselemente in der Response</td>
   * </tr>
   * <tr>
   * <td> sort - criteria</td>
   * <td> Sortierungsart der Ergebnisse</td>
   * </tr>
   * <tr>
   * <td> sort - direction</td>
   * <td> Sortierungsrichtung</td>
   * </tr>
   * <tr>
   * <td> products - id</td>
   * <td> Product Id</td>
   * </tr>
   * <tr>
   * <td> products - productType</td>
   * <td> Reise ohne Flug = Cruise & Reise mit Flug = CruisePackage</td>
   * </tr>
   * <tr>
   * <td> products - serviceReferences - serviceId</td>
   * <td> Id des zugehörigen Services</td>
   * </tr>
   * <tr>
   * <td> products - serviceReferences - serviceVariantId</td>
   * <td> Id der zugehörigen Service-Variation</td>
   * </tr>
   * <tr>
   * <td> products - priceInformation - amount</td>
   * <td> Preis des Angebots</td>
   * </tr>
   * <tr>
   * <td> products - priceInformation - passengerPrices - id</td>
   * <td> Fortlaufende Nummer der 'passengerPrices'-Objekte </td>
   * </tr>
   * <tr>
   * <td> products - priceInformation - passengerPrices - amount</td>
   * <td> Preis für den Passagier-Typ ('title')</td>
   * </tr>
   * <tr>
   * <td> products - priceInformation - passengerPrices - title</td>
   * <td> Typ des Passagiers</td>
   * </tr>
   * <tr>
   * <td> products - priceInformation - priceDetails - priceType</td>
   * <td> Zum Produkt gehörenden Preis-Typ<</td>
   * </tr>
   * <tr>
   * <td> services - id</td>
   * <td> Id des Angebots</td>
   * </tr>
   * <tr>
   * <td> services - flightServices - departureAirport</td>
   * <td> Start-Flughafen, IATA-Code</td>
   * </tr>
   * <tr>
   * <td> services - flightServices - arrivalAirport</td>
   * <td> Ziel-Flughafen, IATA-Code</td>
   * </tr>
   * <tr>
   * <td> services - flightServices - departureDate</td>
   * <td> Tag des Abflugs, yyyy-mm-dd</td>
   * </tr>
   * <tr>
   * <td> services - flightServices - arrivalDate</td>
   * <td> Tag der Ankunft, yyyy-mm-dd</td>
   * </tr>
   * <tr>
   * <td> services - flightServices - productCode</td>
   * <td> Flug-Leistung Buchungscode</td>
   * </tr>
   * <tr>
   * <td> services - flightServices - bookingClassCode</td>
   * <td> Code der Buchungs-Klasse</td>
   * </tr>
   * <tr>
   * <td> services - flightServices - requestCode</td>
   * <td> Request Code für die Flugleistung</td>
   * </tr>
   * <tr>
   * <td> services - flightServices - direction</td>
   * <td> Richtung des Fluges (Hinflug = Outbound & Rückflug = Inbound)</td>
   * </tr>
   * <tr>
   * <td> services - cruiseService - journeyIdentifier</td>
   * <td> TripCode der Reise</td>
   * </tr>
   * <tr>
   * <td> services - cruiseService - startDate</td>
   * <td> Start-Datum der Reise</td>
   * </tr>
   * <tr>
   * <td> services - cruiseService - endDate</td>
   * <td> End-Datum der Reise </td>
   * </tr>
   * <tr>
   * <td> services - cruiseService - packageReference</td>
   * <td> ePackage-Code</td>
   * </tr>
   * <tr>
   * <td> services - cruiseService - shipCode</td>
   * <td> Schiffs-Buchungscode</td>
   * </tr>
   * <tr>
   * <td> services - cruiseService - requestCode</td>
   * <td> Request-Code für die Kreuzfahrtleistung</td>
   * </tr>
   * <tr>
   * <td> services - cruiseService - location - routeGroupCode</td>
   * <td> Code der Routen-Gruppe</td>
   * </tr>
   * <tr>
   * <td> services - cruiseService - location - originAirports</td>
   * <td> Liste der Flughäfen nahe des Start-Hafens</td>
   * </tr>
   * <tr>
   * <td> services - cruiseService - location - originAirports</td>
   * <td> Liste der Flughäfen nahe des End-Hafens</td>
   * </tr>
   * <tr>
   * <td> services - cruiseService - location - region</td>
   * <td> Region der Reise</td>
   * </tr>
   * <tr>
   * <td> services - cruiseService - cruiseVariants - id</td>
   * <td> Id des Angebots</td>
   * </tr>
   * <tr>
   * <td> services - cruiseService - cruiseVariants - cabin - cabinCode</td>
   * <td> Kabinen-Code</td>
   * </tr>
   * <tr>
   * <td> services - cruiseService - cruiseVariants - cabin - cabinType</td>
   * <td> Kabinen-Typ-Code</td>
   * </tr>
   * <tr>
   * <td> services - cruiseService - cruiseVariants - cabin - tariffType</td>
   * <td> TarifTyp des Angebots</td>
   * </tr>
   * <tr>
   * <td> services - cruiseService - cruiseVariants - boardCode</td>
   * <td> Code des Boards (Verpflegung)</td>
   * </tr>
   * </table>
   *
   *
   * @param requestBody
   * @returns cruiseListResponse response included cruise offers matching the given request search criteria
   * @throws ApiError
   */
  public postCruiseList(
    requestBody: cruiseListRequest,
  ): CancelablePromise<cruiseListResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/cruiseList',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad input parameter`,
        401: `Unauthorized`,
        403: `Api gateway error`,
        500: `Internal Server Error`,
        503: `Service Unavailable`,
      },
    });
  }
}
